import { useEffect, useState } from "react";
import { scrollToId } from "@/lib/scroll";
import Logo from "./Logo";

const LINKS = [
  { id: "#overview", label: "Overview" },
  { id: "#how", label: "How it works" },
  { id: "#forecast", label: "Forecast split" },
  { id: "#see", label: "What users see" },
  { id: "#found", label: "What we found" },
  { id: "#fee", label: "Fee & scope" },
  { id: "#timeline", label: "Timeline" },
  { id: "#risks", label: "Risks" },
  { id: "#decisions", label: "Open decisions" },
];

export default function Nav() {
  const [active, setActive] = useState("#overview");

  useEffect(() => {
    const secs = LINKS.map((l) => document.querySelector(l.id));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(`#${e.target.id}`);
        });
      },
      { rootMargin: "-30% 0px -60% 0px" }
    );
    secs.forEach((s) => s && io.observe(s));
    return () => io.disconnect();
  }, []);

  const go = (e, id) => {
    e.preventDefault();
    scrollToId(id);
  };

  return (
    <div className="sticky top-0 z-40 bg-paper/95 backdrop-blur border-b border-hair" data-testid="site-nav">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 flex items-center gap-4">
        <a href="#top" data-testid="nav-logo-link" onClick={(e) => go(e, "#top")} className="flex items-center gap-2.5 shrink-0 py-2.5">
          <Logo className="h-5 w-auto" />
          <span
            className="hidden md:inline-flex items-center font-mono text-[10px] uppercase tracking-[0.12em] text-fog border-l border-hair pl-2.5"
            data-testid="nav-client-mark"
          >
            <span className="text-coal font-medium mr-1">&times;</span> MMG
          </span>
        </a>
        <nav className="flex gap-1 overflow-x-auto py-2" style={{ scrollbarWidth: "none" }}>
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.id}
              data-testid={`nav-link-${l.id.slice(1)}`}
              onClick={(e) => go(e, l.id)}
              className={`font-mono text-[11px] sm:text-[12px] whitespace-nowrap rounded px-2.5 py-1.5 transition-colors duration-200 ${
                active === l.id
                  ? "bg-coal text-white"
                  : "text-fog hover:text-coal hover:bg-sunk"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
}
